import gql from 'graphql-tag';

const GET_EVENTS_USERS_STATISTICS = gql`
  query eventsUsersStatistics($company: String!, $start: String!, $end: String!, $site: String) {
    eventsUsersStatistics(company: $company, start: $start, end: $end, site: $site) {
      stats {
        event_maker_id
        event_id
        event_title
        event_style
        event_spots
        event_location
        event_site
        event_coins
        event_date
        event_date_end
        event_duration
        event_zoom_url
        event_is_live
        instructor_id
        instructor_name
        instructor_lastname
        instructor_email
        user_id
        user_name
        user_lastname
        user_email
        user_id_number
        registered_users_count
        verified_users_count
        waiting_list_count
      }
      aggregated {
        totalUniqueParticipants
        totalCheckIns
        totalSessions
        averageFrequency
        regularParticipants
        weeklyBreakdown {
          week
          sessions
          attendance
          avgPerSession
        }
        dailyBreakdown {
          date
          day
          sessions
          attendance
          popularClasses
        }
        participantTypes {
          type
          count
          percentage
        }
        peakHours {
          hour
          sessions
          avgAttendance
        }
        topClasses {
          classType
          sessions
          totalAttendance
          avgPerSession
        }
        topParticipants {
          employeeName
          sessions
          favoriteClass
          streakDays
        }
      }
      rawData {
        event_maker_id
        event_id
        event_title
        event_location
        event_site
        event_coins
        event_date
        user_id
        user_name
        user_lastname
        user_email
        user_id_number
        check_in_count
      }
    }
  }
`;

export default GET_EVENTS_USERS_STATISTICS;